import { signInAnonymously } from 'firebase/auth';
import { auth, initTestFirebaseApp, clearAnonAuthCache } from './firebase';

export function isTestIdentityEnabled(): boolean {
  return import.meta.env.VITE_ENABLE_TEST_IDENTITIES === 'true';
}

export async function signInAsTestUser(slot: number): Promise<string> {
  if (!isTestIdentityEnabled()) {
    throw new Error('Test identities are not enabled (VITE_ENABLE_TEST_IDENTITIES is not set)');
  }

  console.log('[TestIdentity] initTestFirebaseApp("test-attendee-' + slot + '")');
  initTestFirebaseApp(`test-attendee-${slot}`);

  console.log('[TestIdentity] clearAnonAuthCache()');
  clearAnonAuthCache();

  console.log('[TestIdentity] auth.currentUser before signIn:', auth.currentUser?.uid || 'null');
  const credential = await signInAnonymously(auth);
  console.log('[TestIdentity] signInAnonymously returned UID:', credential.user.uid);
  return credential.user.uid;
}
